import { useCallback } from 'react';
import { downloadPDF } from 'services/pdf.service';
import prepareManifestData from 'modules/prepare-manifest-data/prepare-manifest-data';
import { getLabel } from 'services/pallets.service';
import { print } from 'services/printer.service';
import { getMessageFromAxiosError } from 'modules/message-factory/message-factory';
import { useZebra } from 'context/ZebraProvider';
import { useAlert } from 'context/AlertProvider';

export function usePrintManifestAndPalletLabel(setPrinting) {
  const zebra = useZebra();
  const alert = useAlert();
  const printManifestAndPalletLabel = useCallback(
    async (manifest) => {
      try {
        setPrinting(true);
        await downloadPDF(
          prepareManifestData(manifest),
          'dropshipments-manifest',
        );
        try {
          const { data: palletLabel } = await getLabel(manifest.pallet_id);
          await print(zebra, palletLabel?.content);
          await print(zebra, palletLabel?.content);
        } catch (error) {
          alert.current.error('Error imprimiendo etiqueta de pallet');
        }
      } catch (error) {
        alert.current.error(getMessageFromAxiosError(error));
      } finally {
        setPrinting(false);
      }
    },
    [alert, zebra, setPrinting],
  );

  return { printManifestAndPalletLabel };
}
